# VPNDetectionModal.vue
<script setup>
import { TransitionRoot, TransitionChild } from "@headlessui/vue";
import { useLegitimuzVerification } from "@/composables/base/useLegitimuzVerification";
import ApiService from "@/services/ApiService";
import { useAuthStore } from "@stores/auth.js";

const authStore = useAuthStore();

const model = defineModel();

const emit = defineEmits(["update:modelValue"]);
const { checkLegitimuzStatus } = useLegitimuzVerification();
const isLoading = ref(false);
const isVisible = ref(model.value);

const handleDisableVPN = async () => {
  try {
    isLoading.value = true;
    const newToken = await ApiService.refreshToken();

    if (!newToken && authStore.isLoggedIn) {
      throw new Error("Failed to refresh token");
    }

    await checkLegitimuzStatus(true);

    closeModal();
  } catch (error) {
    console.error("Error during VPN check process:", error);
  } finally {
    isLoading.value = false;
  }
};

const closeModal = () => {
  isVisible.value = false;
  emit("update:modelValue", false);
};

const showModal = () => {
  isVisible.value = true;
  emit("update:modelValue", true);
};

watch(model, (value) => {
  console.log(model)
  if (value) {
    showModal();
  }
});
</script>

<template>
  <TransitionRoot
    appear
    :show="isVisible"
    as="div"
    class="scrollbar-hide fixed top-0 z-[53] h-screen w-screen"
    v-scroll-lock="true"
    tabindex="-1"
  >
    <TransitionChild
      as="template"
      enter="duration-300 ease-out"
      enter-from="opacity-0"
      enter-to="opacity-100"
      leave="duration-200 ease-in"
      leave-from="opacity-100"
      leave-to="opacity-0"
    >
      <div class="fixed inset-0 bg-black/80" @click="closeModal" />
    </TransitionChild>

    <div class="scrollbar-hide fixed inset-0 overflow-y-auto rounded-md">
      <div class="scrollbar-hide flex min-h-full items-center justify-center text-center md:p-4">
        <TransitionChild
          as="div"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <div
            class="scrollbar-hide relative flex h-fit w-full transform flex-col gap-4 overflow-y-auto overflow-x-hidden bg-brand-background text-left align-middle shadow-xl transition-all sm:max-w-md sm:rounded-md"
          >
            <div>
              <div class="relative flex w-full flex-row justify-center pt-5">
                <div class="flex items-center gap-2">
                  <Icon name="fa6-solid:shield-halved" class="text-red-500 text-xl" />
                  <h3 class="text-lg font-bold leading-6 text-white">VPN DETECTADA</h3>
                </div>
              </div>
            </div>

            <div class="p-3 md:p-4">
              <p class="text-gray-300 mb-4">
                Identificamos que você está utilizando uma VPN. Para garantir o funcionamento
                correto do nosso site, pedimos que desative a VPN e recarregue a página.
              </p>
            </div>

            <div class="p-2 pb-6 flex justify-center">
              <button
                @click="handleDisableVPN"
                :disabled="isLoading"
                class="bg-brand-primary hover:bg-brand-primary-dark text-white font-medium px-4 py-2 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                <span v-if="isLoading" class="animate-spin">
                  <Icon name="fa6-solid:circle-notch" />
                </span>
                <span>{{ isLoading ? "Processando..." : "Desativar VPN e continuar" }}</span>
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </div>
  </TransitionRoot>
</template>
